import { setPrismMenu } from 'actions/ui';
import BlobImage from 'components/blobImage';
import PageHeader from 'components/general/pageHeader';
import PathwayDetails from 'components/prism/pathwayDetails';
import { Loading } from '@salesperformanceint/e4shared';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGet } from 'services';

export const Pathway = ({ match }) => {
    const dispatch = useDispatch();
    const [data, setData] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        dispatch(setPrismMenu('Pathways'));
    }, []);

    React.useEffect(() => {
        const pathwayId = match.params.id ? parseInt(match.params.id, 10) : null;

        apiGet(`pathway-library/${pathwayId}`, user.guid, response => {
            setData(response);
            setLoading(false);
        });
    }, [match.params.id]);

    if (loading) return <Loading />;

    return (
        <div id="pathway-page" data-testid="pathway-page">
            <PageHeader metaTitle={data.pathway.name} pathways />
            <div className="prism-top-banner mb30 mtm10">
                {data.pathway.image ? (
                    <BlobImage src={data.pathway.image} folder="pathway_Image" noholder />
                ) : (
                    <img src="/dist/img/defaults/pathway-default.jpg" />
                )}
            </div>
            <PathwayDetails data={data} />
        </div>
    );
};

export default Pathway;
